{
	"frame": {
		"showTable": "Show as table",
		"showChart": "Show as chart"
	},
	"days": {
		"awarded": "Awarded",
		"due": "Due",
		"columnLabel": "{{day}}: {{gold}} gold, {{silver}} silver, {{bronze}} bronze awarded; {{due}} due"
	},
	"pipeline": {
		"label": "Medal pipeline",
		"NOT_SCHEDULED": "Not scheduled",
		"COMPETING": "Competing",
		"WAITING": "Waiting for the desk",
		"AWARDED": "Awarded",
		"NO_MEDALS": "No medals",
		"share": "{{pct}}% of the events",
		"branch": "Settled with no medal"
	},
	"heat": {
		"few": "Few",
		"many": "Many"
	}
}
